import { compose } from 'recompose'
import { connect } from 'react-redux'
import { setAffordabilityMethod } from 'src/actions/affordability'
import { selectModalMethod } from 'src/store/selectors/affordability'

const TabsContainer = compose(
  connect(
    state => ({
      activeTab: selectModalMethod(state)
    }),
    dispatch => ({
      changeTab: tab => () => dispatch(setAffordabilityMethod(tab))
    })
  )
)

export default TabsContainer
